$(document).ready(function(){
  $('.responsive').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  prevArrow: false,
  nextArrow: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
$('.navlink--child').hover(
    function() {
        $(this).siblings('.custom_div').removeClass('hide').addClass('is-visible');
    },
    function() {
        setTimeout(() => {
            if (!$('.custom_div:hover').length) {
                $(this).siblings('.custom_div').removeClass('is-visible').addClass('hide');
            }
        }, 100);
    }
);

$('.custom_div').hover(
    function() {
        $(this).removeClass('hide').addClass('is-visible');
    },
    function() {
        setTimeout(() => {
            if (!$('.navlink--child:hover').length) {
                $(this).removeClass('is-visible').addClass('hide');
            }
        }, 100);
    }
);
// $('.sliderule__wrapper .sliderow__title:nth-child(5)').click(function() {
//     $('.drawer .header__drawer').addClass('hidden');
//   });
});